import { IColumn } from "@fluentui/react";
import {
  creationDateRenderer,
  durationRenderer,
  environmentRenderer,
  modeRenderer,
  runIdRenderer,
  startedByRenderer,
  stagesRenderer,
} from "./rolloutDetailsColumnRenderers";
import {
  ApprovalLinkData,
  PipelineRun,
  Ev2ExperimentStage,
} from "../../../Types";

export function getPipelineRunsColumns({
  loadingApprovals,
  approvalData,
  loadingEv2Links: _loadingEv2Links,
  ev2PortalLinks: _ev2PortalLinks,
  ev2StatusMap,
  ev2StatusLoading,
  onEv2StageClicked,
  abnVariantCount,
}: {
  loadingApprovals: Record<number, boolean>;
  approvalData: Record<number, ApprovalLinkData | null>;
  loadingEv2Links: Record<number, boolean>;
  ev2PortalLinks: Record<number, string | null>;
  ev2StatusMap: Record<number, Ev2ExperimentStage[]>;
  ev2StatusLoading: Record<number, boolean>;
  onEv2StageClicked: (runId: number) => void;
  abnVariantCount?: number;
}): IColumn[] {
  return [
    {
      key: "runId",
      name: "Run ID",
      fieldName: "id",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
      onRender: (run: PipelineRun) =>
        runIdRenderer(run, ev2StatusMap, ev2StatusLoading, loadingApprovals),
    },
    {
      key: "environment",
      name: "Environment",
      fieldName: "environment",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
      onRender: environmentRenderer,
    },
    {
      key: "mode",
      name: "Mode",
      fieldName: "mode",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      onRender: modeRenderer,
    },
    {
      key: "stages",
      name: "Stages",
      fieldName: "stages",
      minWidth: 300,
      maxWidth: 300,
      isResizable: true,
      onRender: (run: PipelineRun) =>
        stagesRenderer(
          run,
          approvalData,
          loadingApprovals,
          ev2StatusMap,
          ev2StatusLoading,
          onEv2StageClicked,
          abnVariantCount,
        ),
    },
    {
      key: "startTime",
      name: "Started at",
      fieldName: "startTime",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      onRender: creationDateRenderer,
    },
    {
      key: "startedBy",
      name: "Started by",
      fieldName: "startedBy",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      onRender: startedByRenderer,
    },
    {
      key: "duration",
      name: "Duration",
      fieldName: "duration",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
      onRender: durationRenderer,
    },
  ];
}
